export const config: any = {

    defaultLocale: "us",
    API_KEY: "",
    APP_URL: "http://3.132.226.69:8080/dentalfirst-saas", //new linux server
  
}